import React from 'react';
import { ToggleButtonGroup, ToggleButton, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const FilterControls = ({ 
  filter, 
  onFilterChange, 
  selectedYear, 
  onYearChange, 
  availableYears = [] 
}) => (
  <>
    <ToggleButtonGroup
      color="primary"
      value={filter}
      exclusive
      onChange={(e, newValue) => {
        if (newValue !== null) onFilterChange(newValue);
      }}
      sx={{ mb: 2 }}
    >
      <ToggleButton value="all">Siempre</ToggleButton>
      <ToggleButton value="byYear">Por Año</ToggleButton>
      <ToggleButton value="lastMonth">Último Mes</ToggleButton>
    </ToggleButtonGroup>
    
    {filter === "byYear" && (
      <FormControl sx={{ minWidth: 120, ml: 2 }} size="small">
        <InputLabel>Año</InputLabel>
        <Select
          value={selectedYear}
          label="Año"
          onChange={(e) => onYearChange(e.target.value)}
        >
          {availableYears.map(year => (
            <MenuItem key={year} value={year}>{year}</MenuItem>
          ))}
        </Select>
      </FormControl>
    )}
  </>
);

export default FilterControls;
